window.slideToggleDiv = (id) => {
    const targetElement = document.getElementById(id);
    if (!targetElement) {
      console.error(`Element with ID ${id} not found`);
      return;
    }
  
    // Hide all elements with class 'contact-form'
    const allForms = document.querySelectorAll('.contact-form');
    allForms.forEach(form => {
      if (form !== targetElement && form.style.display !== 'none') {
        form.style.height = form.scrollHeight + 'px';
        form.style.transition = 'height 0.3s ease-in-out';
        setTimeout(() => {
          form.style.height = '0px';
        }, 10);
        setTimeout(() => {
          form.style.display = 'none';
        }, 300);
      }
    });
  
    // Slide down the target element if hidden
    if (targetElement.style.display === 'none' || targetElement.style.display === '') {
      targetElement.style.display = 'block';
      targetElement.style.height = '0px';
      targetElement.style.overflow = 'hidden';
      targetElement.style.transition = 'height 0.3s ease-in-out';
      const height = targetElement.scrollHeight;
      targetElement.style.height = `${height}px`;
      setTimeout(() => {
        targetElement.style.height = 'auto';
        // Scroll to the target element
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    } else {
      // Slide up the target element if visible
      targetElement.style.height = targetElement.scrollHeight + 'px';
      targetElement.style.transition = 'height 0.3s ease-in-out';
      setTimeout(() => {
        targetElement.style.height = '0px';
      }, 10);
      setTimeout(() => {
        targetElement.style.display = 'none';
      }, 300);
    }
  }